import IndexLayout from "../Layouts/IndexLayout";
import MainLayout from "../Layouts/MainLayout";
import PagesLayaut from '../Layouts/PagesLayaut';
import { createBrowserRouter } from "react-router-dom";
import Productos from '../Pages/Productos/Productos';
import Usuarios from '../Pages/Usuarios/Usuarios';
import Banners from "./Banners/Banners";
import Main from "./Main/Main";
import Contacto from "./Contacto/Contacto";
import Categorias from "./Categorias/Categorias";
import Mesas from "./Mesas/Mesas";
import Pedidos from "./Pedidos/Pedidos";
import PageDetail from '../Pages/PageDetail/PageDetail';
import Configuracion from "./Configuracion/Configuracion";
import KDS from "./KDS/KDS";
import POS from "./POS/POS";
import Meseros from "./Meseros/Meseros";
import Gastos from "./Gastos/Gastos";
import Cupones from "./Cupones/Cupones";
import Perfil from "./Perfil/Perfil";
import MenuDigital from "./MenuDigital/MenuDigital";

export const router = createBrowserRouter([
    {
        path: "/",
        element: <IndexLayout />,
    },
    {
        path: "/menu",
        element: <MenuDigital />,
    },
    {
        path: "/menu/:token",
        element: <MenuDigital />,
    },
    {
        path: "/",
        element: <PagesLayaut />,
        children: [
            {
                path: `/producto/:idProducto/:producto`,
                element: <PageDetail />,
            },
        ]
    },
    {
        path: "/",
        element: <MainLayout />,
        children: [
            {
                path: `/dashboard`,
                element: <Main />,
            },
            {
                path: `/dashboard/pos`,
                element: <POS />,
            },
            {
                path: `/dashboard/kds`,
                element: <KDS />,
            },
            {
                path: `/dashboard/meseros`,
                element: <Meseros />,
            },
            {
                path: `/dashboard/gastos`,
                element: <Gastos />,
            },
            {
                path: `/dashboard/cupones`,
                element: <Cupones />,
            },
            {
                path: `/dashboard/codigos`,
                element: <Cupones />, // Alias retrocompatible
            },
            {
                path: `/dashboard/perfil`,
                element: <Perfil />,
            },
            {
                path: `/dashboard/productos`,
                element: <Productos />,
            },
            {
                path: `/dashboard/usuarios`,
                element: <Usuarios />,
            },
            {
                path: `/dashboard/banners`,
                element: <Banners />,
            },
            {
                path: `/dashboard/contacto`,
                element: <Contacto />,
            },
            {
                path: `/dashboard/categorias`,
                element: <Categorias />,
            },
            {
                path: `/dashboard/mesas`,
                element: <Mesas />,
            },
            {
                path: `/dashboard/pedidos`,
                element: <Pedidos />,
            },
            {
                path: `/dashboard/configuracion`,
                element: <Configuracion />,
            },
        ],
    },
]);
